import VueRouter, { Route } from 'vue-router';

import { RouteName } from '../../../routes/routes.constants';
import { FEATURE_QUERY_ENABLED } from '@gig/magic-messages';

export function initFeatureGuard(router: VueRouter) {
    router.beforeEach(async (to, _, next) => {
        const featureSlug = getFeature(to);

        if (!featureSlug) {
            return next();
        }

        const isEnabled = await window.queryBus.query<string, boolean>(
            FEATURE_QUERY_ENABLED,
            featureSlug,
        );

        if (isEnabled) {
            return next();
        }

        return next({
            name: RouteName.PAGE404,
        });
    });
}

export function getFeature(route: Route): string | null {
    const featureSlug = route.matched.find((currRoute) => {
        return currRoute.meta?.featureSlug;
    });
    return featureSlug?.meta?.featureSlug ?? false;
}

export function featureGuard(featureSlug: string) {
    return {
        featureSlug,
    };
}
